export const KeyAccountApprovalStatus = Object.freeze({
    PENDING_RETAILER_APPROVAL: "Pending Retailer Approval",
    APPROVED: "Approved",
    DENIED: "Denied",
    PENDING: "Pending",
    NEW: "New"
})

export const getApprovalStatus = (row) => {
    if (!row?.approverEmailedSentAt && (!row?.status || row?.status === "PENDING")) {
        return KeyAccountApprovalStatus.NEW
    }
    return row?.status ? KeyAccountApprovalStatus[row.status] : KeyAccountApprovalStatus.PENDING
}

export const getCategoryNameFromTag = (categoriesWithListSubCat, tag, productLevel) => {
    if (productLevel === "CATEGORY" || productLevel === "BRANDCAT") {
        return categoriesWithListSubCat.find(item => item.value === tag)?.displayName ?? tag
    } else if (productLevel === "DEPARTMENT") {
        // TODO: what to display if product level is department?
        return tag
    } else {
        return categoriesWithListSubCat.find(item => item.subcategories.includes(tag))?.displayName ?? tag
    }
}

export const flattenSubcatFromCategories = (categories) => {
    return categories.map((category) => {
        const subcategories = category.subcategories.map(subcategory => subcategory.value)
        return {...category, subcategories: subcategories}
    })
}

export const mapKeyAccountDetails = (subscriptions, categoriesWithListSubCat, companiesWithContacts) => {
    const groupedSubscriptions = new Map()
    const filteredSubscriptions = subscriptions.filter(subscription => {
        const companyType = companiesWithContacts
            .find(company => company.geoFamilyId?.toString() === subscription.sec_mkt_key?.toString())?.type ?? "";
        return companyType === "Key Account Retailer"
    })

    filteredSubscriptions.forEach((subscription) => {
        const productCode = subscription.sec_prd_key.split('|')[1]
        const categoryName = getCategoryNameFromTag(categoriesWithListSubCat, productCode, subscription.prd_lvl)
        const groupId = `${subscription.sec_mkt_key}|${subscription.companySalesforceId}|${categoryName}`

        const subscriptions = groupedSubscriptions.get(groupId);
        subscriptions ? subscriptions.push(subscription) : groupedSubscriptions.set(groupId, [subscription]);
    })
    return groupedSubscriptions
}

export const flattenGroupedSubscriptions = (groupedSubscriptions, geoFamilyIds, companiesWithContacts) => {
    return Array.from(groupedSubscriptions.entries()).map(([key, subscriptions]) => {
        const firstSubscription = subscriptions[0];
        const retailerName = geoFamilyIds.find(geoFamilyId => geoFamilyId.value?.toString() === firstSubscription.sec_mkt_key?.toString())?.displayName
        const retailer = companiesWithContacts
            .find(company => company.geoFamilyId?.toString() === firstSubscription.sec_mkt_key?.toString())
        const contacts = retailer?.spinsContacts?.val
        const spinsOwner = contacts?.find(spinsContact => spinsContact.type === "SPINS Owner")
        const accountManager = contacts?.find(spinsContact => spinsContact.type === "Account Manager")
        const categoryName = key.split("|")[2]

        return {
            id: key,
            createdAt: firstSubscription.createdAt,
            statusUpdatedAt: firstSubscription.statusUpdatedAt,
            statusUpdatedBy: firstSubscription.statusUpdatedBy,
            companyName: firstSubscription.displayName,
            status: firstSubscription.status,
            approverEmailedSentAt: firstSubscription.approverEmailedSentAt,
            subscriptionIds: firstSubscription.subscriptionIds,
            note: firstSubscription.note_text,
            disabledMailer: firstSubscription.disabledMailer,
            lastModifiedBy: firstSubscription.lastModifiedBy,
            totalSalesForGeographyCategory: firstSubscription.totalSalesForGeographyCategory,
            totalSalesForGeography: firstSubscription.totalSalesForGeography,
            brands: firstSubscription.brands,
            retailerName: retailerName ?? firstSubscription.sec_mkt_key,
            categoryName: categoryName,
            spinsOwner: `${spinsOwner?.fname ?? ""} ${spinsOwner?.lname ?? ""}`,
            accountManager: `${accountManager?.fname ?? ""} ${accountManager?.lname ?? ""}`,
            retailerSfid: retailer?.id,
        }
    })
}
